const tasks = [
  {
    taskName: 'Worries',
    prompt:
      'Without stopping, write down everything that is churning around in your mind. Once it is out of your head, give yourself permission to leave it here and come back to it later with a clearer head.',
    picturePrompt:
      'Upload a picture of something or someone that calms you and helps remove your worries.',
  },
  {
    taskName: 'Reflection',
    prompt:
      'Sit quietly for a few minutes, just breathing and listening to your body before you start writing. What is it telling you? Where do you feel strong, healthy, energetic, relaxed? Where do you feel tense, worried, uncomfortable, tired? What is asking for more attention?',
    picturePrompt:
      'Upload a picture of a place that you like to visit that helps you be calm and reflective.',
  },
  {
    taskName: 'One Word',
    prompt:
      'Pick a single positive word that you want to focus on today – such as joy, gratitude, love or courage. Journal about all the ways you have experienced this word lately and all the ways you want to.',
    picturePrompt:
      'Upload a picture of something or someone that makes you think of this word.',
  },
  {
    taskName: 'Victories',
    prompt:
      'Write a list of your recent accomplishments and victories, no matter how small. Celebrate each one individually.',
    picturePrompt: 'Upload a selfie. Try a victory pose!',
  },
  {
    taskName: 'Habits',
    prompt:
      'Write about a habit or activity you do that improves your mood or stress level. Describe how you transform when you are engaged in this practice. How do you feel? How can you do this more often?',
    picturePrompt:
      'Upload a picture of you engaging in this habit or activity.',
  },
  {
    taskName: 'Lyrics',
    prompt:
      'Think about the lyrics to a song that makes you happy.  What is it about this song that makes you feel this way?',
    picturePrompt:
      'Upload a picture of something that reminds you of this song or how this song makes you feel.',
  },
  {
    taskName: 'Gratitude',
    prompt:
      'Take a second to reflect on something in your life that you are grateful for right now. Write about why you feel that way.',
    picturePrompt:
      'Upload a picture of something or someone that you are grateful for.',
  },
];

export default tasks;
